(() => {
  const elementName = 'lpl-finished-batch-testing';

  if (customElements.get(elementName)) return;

  class LplFinishedBatchTesting extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;

      this.trigger = this.querySelector('[data-lpl-fbt-trigger]');
      this.dialog = this.querySelector('[data-lpl-fbt-dialog]');
      this.closeButton = this.querySelector('[data-lpl-fbt-close]');
      this.sectionToggles = Array.from(this.querySelectorAll('[data-lpl-fbt-section-toggle]'));

      if (!this.trigger || !this.dialog || !this.closeButton) return;

      this.controller = new AbortController();
      const options = { signal: this.controller.signal };

      this.trigger.addEventListener('click', (event) => this.open(event), options);
      this.closeButton.addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => this.closeFromBackdrop(event), options);
      this.dialog.addEventListener('close', () => this.restoreFocus(), options);

      this.sectionToggles.forEach((toggle) => {
        toggle.addEventListener('click', () => this.toggleSection(toggle), options);
      });
    }

    disconnectedCallback() {
      if (!this.controller) return;
      this.controller.abort();
      this.controller = null;
    }

    /* Sections ------------------------------------------------------------ */

    toggleSection(toggle) {
      const section = toggle.closest('[data-lpl-fbt-section]');
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));

      if (!section || !panel) return;

      const willOpen = toggle.getAttribute('aria-expanded') !== 'true';

      toggle.setAttribute('aria-expanded', String(willOpen));
      section.classList.toggle('is-open', willOpen);
      panel.hidden = !willOpen;
    }

    /* Dialog -------------------------------------------------------------- */

    open(event) {
      if (typeof this.dialog.showModal !== 'function') return;

      event.preventDefault();
      if (this.dialog.open) return;

      this.returnFocusTo = this.trigger;
      this.dialog.showModal();
      requestAnimationFrame(() => this.closeButton.focus({ preventScroll: true }));
    }

    closeFromBackdrop(event) {
      if (event.target !== this.dialog) return;

      const bounds = this.dialog.getBoundingClientRect();
      const outside = event.clientX < bounds.left
        || event.clientX > bounds.right
        || event.clientY < bounds.top
        || event.clientY > bounds.bottom;

      if (outside) this.dialog.close();
    }

    restoreFocus() {
      if (this.returnFocusTo && this.returnFocusTo.isConnected) {
        this.returnFocusTo.focus({ preventScroll: true });
      }
      this.returnFocusTo = null;
    }
  }

  customElements.define(elementName, LplFinishedBatchTesting);
})();
